var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2098,
    height: 481,
    viewBox: "0 0 2098 481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "backgroud_wave_1-a",
    x1: "12.607%",
    x2: "89.976%",
    y1: "51.099%",
    y2: "47.612%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C06BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#47BAE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backgroud_wave_1-b",
    x1: "23.384%",
    x2: "83.039%",
    y1: "52.608%",
    y2: "48.111%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C06BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#47BAE8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19,0 L0,276 L19,0 Z",
    transform: "translate(13 205)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19,0 L0,276 L19,0 Z",
    transform: "translate(13 205)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#backgroud_wave_1-a)",
    d: "M2098,126 C2098,126 2035.24019,72.4749147 1831.37009,222.487457 C1627.5,372.5 1465.5,212 1465.5,212 C1465.5,212 1200.23652,-28.5170004 923.75546,212.054855 C647.27439,452.626711 418,208.5 418,208.5 C418,208.5 279.288619,53.2723092 3.5,205 C-2.74167406,208.433915 2.5,205 2.5,205 C2.5,205 3.5,205 3.5,205 L3.309128,481 L2098,481 L2098,126 Z",
    opacity: 0.654
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#backgroud_wave_1-b)",
    d: "M2.5,205 C95.054724,228.666667 164.388057,240.5 210.5,240.5 C315.5,240.5 403.5,193.5 403.5,193.5 C403.5,193.5 818.67184,-51.5178164 1068.64043,135.011171 C1318.60902,321.540158 1295.74316,367.920507 1577.62158,122.710253 C1765.54053,-40.7632489 1939,-40.8333333 2098,122.5 L2097.80431,481 L2.5,481 C2.5,481 2.5,389 2.5,205 Z",
    opacity: 0.773
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.c9501c1898c07634e4095b1ebaf87398.svg";
export { ForwardRef as ReactComponent };